import React from 'react';
import { Virtuoso } from 'react-virtuoso';
import Checkbox from '../../../components/Checkbox';
import SideNavItem from '../../../components/sideNav/SideNavItem';

export default function ElementStatusV2FilterList({
  items = [],
  onToggle = () => {},
  selectedIds = [],
  small = true,
}) {
  return (
    <Virtuoso
      data={items}
      initialItemCount={Math.min(items.length, 20)}
      style={{ height: '100%', width: '100%' }}
      itemContent={(index, item) => (
        <SideNavItem
          key={item.id}
          onClick={() => onToggle(item.id)}
          small={small}
          stopRightComponentClickPropagation
          subtitle={item.subtitle}
          title={item.name}
          tooltip={item.tooltip}
          rightComponent={
            <Checkbox
              id={`submenu-${item.id}`}
              isChecked={item.selected ?? selectedIds.includes(item.id)}
              onChange={() => onToggle(item.id)}
            />
          }
        />
      )}
    />
  );
}
